// extracted by mini-css-extract-plugin
export default {"mainTitle":"BecomeLessor_mainTitle__ZXcsr","mainPicture":"BecomeLessor_mainPicture__DjtAi","borderBackground":"BecomeLessor_borderBackground__0rHwe"};